import {forwardRef, Fragment} from 'react';
import {cn} from '../lib/cn';
import {type CheckboxOption} from '../checkbox';
import {CheckboxDropdownGroup} from './CheckboxDropdownGroup';
import {
  DropdownMenuGroup,
  DropdownMenuLabel,
  DropdownMenuSeparator,
} from './DropdownMenu';

export interface CheckboxDropdownGroupConfig {
  label: string;
  options: CheckboxOption[];
  value: CheckboxOption[] | CheckboxOption | null;
  onChange: (selectedValues: CheckboxOption[] | CheckboxOption | null) => void;
  multiple?: boolean;
}

export interface CheckboxDropdownMultiGroupProps {
  groups: CheckboxDropdownGroupConfig[];
  className?: string;
  keepOpenOnSelect?: boolean;
}

const CheckboxDropdownMultiGroup = forwardRef<
  HTMLDivElement,
  CheckboxDropdownMultiGroupProps
>(({groups, className = '', keepOpenOnSelect}, ref) => {
  return (
    <div ref={ref} className={cn('space-y-1', className)}>
      {groups.map((group, index) => (
        <Fragment key={group.label}>
          <DropdownMenuGroup>
            <DropdownMenuLabel>{group.label}</DropdownMenuLabel>
            {group.multiple ? (
              <CheckboxDropdownGroup
                multiple={true}
                onChange={
                  group.onChange as (selectedValues: CheckboxOption[] | null) => void
                }
                options={group.options}
                value={group.value as CheckboxOption[] | null}
                keepOpenOnSelect={keepOpenOnSelect}
              />
            ) : (
              <CheckboxDropdownGroup
                multiple={false}
                onChange={
                  group.onChange as (selectedValues: CheckboxOption | null) => void
                }
                options={group.options}
                value={group.value as CheckboxOption | null}
                keepOpenOnSelect={keepOpenOnSelect}
              />
            )}
          </DropdownMenuGroup>
          {index < groups.length - 1 && <DropdownMenuSeparator />}
        </Fragment>
      ))}
    </div>
  );
});

CheckboxDropdownMultiGroup.displayName = 'CheckboxDropdownMultiGroup';

export {CheckboxDropdownMultiGroup};
